import { CurrentUser } from "../../hooks/user/useCurrentUser";

export const userInitials = (user: CurrentUser) => {
  return [user.firstName, user.lastName]
    .map((name) => (name.length >= 1 ? name[0].toUpperCase() : ""))
    .join("");
};
